export default "__VITE_ASSET__B30H7TL7__";